<script>
export let value = false;
export let name;
export let label;
export let mandatory = false;
</script>

<div class="checkbox">
  <input type="checkbox" id={name} required={mandatory} bind:checked={value}>
  <label for={name}>{@html label}</label>
</div>

<style>
.checkbox {
  display: flex;
  align-items: flex-start;
  margin-bottom: 3rem;
  width: 100%;
}

input[type="checkbox"] {
  position: relative;
  top: 4px;
  margin: 0;
  margin-right: 1rem;
  flex: 0 0 20px;
}


.checkbox label a {
  color: #ed1d24;
}

</style>
